
const decideABTest = (featureConfig) => {
    const randomNumber = Math.random() * 100;

    if (featureConfig.enabled === 100) {
        return true;
    }

    return featureConfig.enabled <= randomNumber;
}

const generateABFeatureConfigObject = (featureConfig, decision) => {
    return {
        decision: decision,
        version: 'version' in featureConfig ? featureConfig.version : 0,
    }
}

const getUrlForcedABTests = () => {
    const configuration = getRawFeatureConfiguration();

    const urlParams   = new URLSearchParams(document.location.search);
    const urlParamKey = 'features';

    if (! urlParams.has(urlParamKey)) {
        return {};
    }

    const forcedFeaturesString = urlParams.get(urlParamKey).split(',');
    const forcedFeatures       = {};

    for (let forcedFeatureString of forcedFeaturesString) {
        const [forcedFeature, forcedFeatureValue] = forcedFeatureString.split(':');

        if (! (forcedFeature in configuration)) {
            // Unknown A/B test

            continue;
        }

        if (! configuration[forcedFeature].public_url_override) {
            // A/B test is not allowed to be overwritten

            continue;
        }

        console.warn(`Forced A/B test "${forcedFeature}" to ${forcedFeatureValue === 'on'}`);

        forcedFeatures[forcedFeature] = forcedFeatureValue === 'on';
    }

    return forcedFeatures;
}

const getLocalStorageFeatureVariantsConfig = () => {
    const key = 'feature_variants_config';

    const configValue = window.localStorage.getItem(key);

    if (!configValue) {
        return {};
    }

    return JSON.parse(configValue);
}

const setLocalStorageFeatureVariantsConfig = (featureVariantsConfig) => {
    const key = 'feature_variants_config';

    window.localStorage.setItem(key, JSON.stringify(featureVariantsConfig));
}


export const getRawFeatureConfiguration = () => {
    if (! ('feature_config' in window)) {
        return {};
    }

    if (typeof window.feature_config !== 'object') {
        return {};
    }

    return window.feature_config;
};

export const updateDecidedABTests = () => {
    const configuration = getRawFeatureConfiguration();
    const forcedABTests = getUrlForcedABTests();

    const featureVariantsConfig = {};
    const oldFeatureVariantsConfig = getLocalStorageFeatureVariantsConfig();

    for (const [feature, featureConfig] of Object.entries(configuration)) {
        const decision = decideABTest(featureConfig);

        // Is the A/B test being forced by the user?
        if (feature in forcedABTests) {
            featureVariantsConfig[feature] = generateABFeatureConfigObject(featureConfig, forcedABTests[feature]);

            continue;
        }

        if (feature in oldFeatureVariantsConfig) {
            const oldFeatureConfig = oldFeatureVariantsConfig[feature];

            // Has the A/B test been updated?
            if (oldFeatureConfig.version < featureConfig.version) {
                // Make a new decision again
                featureVariantsConfig[feature] = generateABFeatureConfigObject(featureConfig, decision);

                continue;
            }

            // Same version, just use the existing decision
            featureVariantsConfig[feature] = oldFeatureConfig;

            continue;
        }

        // New A/B test, make a decision
        featureVariantsConfig[feature] = generateABFeatureConfigObject(featureConfig, decision);
    }

    setLocalStorageFeatureVariantsConfig(featureVariantsConfig);
}

export const isFeatureEnabled = (feature) => {
    const featureVariantsConfig = getLocalStorageFeatureVariantsConfig();

    if (! (feature in featureVariantsConfig)) {
        console.warn(`A/B test "${feature}" was requested, but that isn't a known A/B test`);

        return false;
    }

    return featureVariantsConfig[feature].decision;
};

export const sendDecidedABTestsToGA = () => {
    if (! ('addGADimension' in window)) {
        // Brekz_GA4 module doesnt seem to be available

        return;
    }

    const configuration = getRawFeatureConfiguration();

    for (const [feature] of Object.entries(configuration)) {
        window.addGADimension(feature, isFeatureEnabled(feature));
    }
}

